<div style="height: 100%; display: flex; align-items: center;">
  <button mat-button class="notification-dropdown" #menuTrigger="matMenuTrigger"
          [matMenuTriggerFor]="notificationMenu">
    <div class="flex-row flex-center-center">
      @if (!(hasUnread$ | async)) {
        <img alt="notifications" src="/assets/slicons/notification.svg"/>
      }
      @if (hasUnread$ | async) {
        <img style="margin-top: 1px" alt="notifications" src="/assets/slicons/notification-in-basket.svg"/>
      }
    </div>
  </button>
</div>
<mat-menu #notificationMenu="matMenu" [overlapTrigger]="false" class="remove-max-width remove-padding">
  <div class="notification-menu" (click)="$event.stopPropagation()">
    <div class="notification-menu-header flex-row flex-center-start">
      <img class="header-icon header-bell" alt="" src="/assets/slicons/notification.svg"/>
      <h4 class="header-title">Notifications</h4>
    </div>
    @if ((notifications$ | async); as notifications) {
      @if (!(hasUnread$ | async)) {
        <div class="empty-message flex-col flex-center-start">
          <img class="caught-up-bell" alt="" src="/assets/slicons/notification.svg"/>
          <h1>You are all caught up!</h1>
          <h4>You don't have any unread notifications.</h4>
        </div>
      } @else {
        <h4 class="mark-all pointer flex-row flex-center-start" (click)="markAllRead(notifications)">
          <em class="mark-all-icon ri-eye-line"></em>
          Mark all as read
        </h4>
      }
      @for (n of notifications; track n.id) {
        @if (!n.viewed) {
          <mat-divider/>
          <h4 class="title-row flex-row flex-center-start">
            <span class="message-icon-container">
              <span class="exclamation-circle">!</span>
            </span>
            <span class="title">{{ n.subject }}</span>
            <em class="mark-one ri-eye-line pointer" (click)="markRead(n)" matTooltip="Mark Read"></em>
          </h4>
          <div class="message-text" [innerHTML]="n.message"></div>
          <div class="message-date"><img class="date-bell" alt="" src="/assets/slicons/notification.svg"/> {{ n.created | date }}</div>
        }
      }
    } @else {
      <div class="flex-container">
        <mat-spinner/>
      </div>
    }
  </div>
</mat-menu>
